import { validate } from 'email-validator';

// Strict: an empty string is not a valid email address.
export const isValidEmail = (email: string): boolean => validate(email.trim());

// For optional email fields — blank is acceptable, but anything typed must be well-formed.
// Shaped for `Header.isInvalid`, which receives the raw cell value.
export const isInvalidOptionalEmail = (value?: string | null): boolean => {
  const trimmed = value?.trim() ?? '';
  return trimmed.length > 0 && !validate(trimmed);
};

export const invalidEmailMessage = (email: string): string =>
  `"${email.trim()}" is not a valid email address.`;
